"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var CodebookLookupSequence_1 = require("../../core/model/codebook/CodebookLookupSequence");

var DateParser_1 = require("../../core/model/data-dictionary/parsers/DateParser");

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");

var PromotionStateEnum_1 = require("../../promotion/model/PromotionStateEnum");

var WindowStateEnum_1 = require("../../window/model/WindowStateEnum");
/**
 * DTO object representing one UI row in approval report CD.
 * @author Zdeněk Straka
 */


var ApprovalReportCDRowDTO =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(ApprovalReportCDRowDTO, _DomainObject_1$Domai);

  function ApprovalReportCDRowDTO(id, nodeId, reportId, level, path, isGroup, entity, entityId, title, promotionCode, promotionName, storeSpecification, promoWorkflowState, windowWorkflowState, cd, cm, windowTypeId, windowTypeName, promoTypeId, promoTypeName, windowName, startWeekDate, daysValid, promoDiscount, workflowNote, windowsCount, skuCount, approveButtons, kpiValues) {
    var _this;

    _classCallCheck(this, ApprovalReportCDRowDTO);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ApprovalReportCDRowDTO).call(this));
    _this.id = id;
    _this.nodeId = nodeId;
    _this.reportId = reportId;
    _this.level = level;
    _this.path = path;
    _this.isGroup = isGroup;
    _this.entity = entity;
    _this.entityId = entityId;
    _this.title = title;
    _this.promotionCode = promotionCode;
    _this.promotionName = promotionName;
    _this.storeSpecification = storeSpecification;
    _this.promoWorkflowState = promoWorkflowState;
    _this.windowWorkflowState = windowWorkflowState;
    _this.cd = cd;
    _this.cm = cm;
    _this.windowTypeId = windowTypeId;
    _this.windowTypeName = windowTypeName;
    _this.promoTypeId = promoTypeId;
    _this.promoTypeName = promoTypeName;
    _this.windowName = windowName;
    _this.startWeekDate = startWeekDate;
    _this.daysValid = daysValid;
    _this.promoDiscount = promoDiscount;
    _this.workflowNote = workflowNote;
    _this.windowsCount = windowsCount;
    _this.skuCount = skuCount;
    _this.approveButtons = approveButtons;
    _this.kpiValues = kpiValues;
    return _this;
  }

  return ApprovalReportCDRowDTO;
}(DomainObject_1.DomainObject);

exports.ApprovalReportCDRowDTO = ApprovalReportCDRowDTO;

ApprovalReportCDRowDTO.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(ApprovalReportCDRowDTO.name);
  return {
    id: builder.str('id'),
    nodeId: builder.str('nodeId'),
    reportId: builder.str('reportId'),
    level: builder.num('level'),
    path: builder.arr(builder.str('path')),
    isGroup: builder.bool('isGroup'),
    entity: builder.opt(builder.str('entity')),
    entityId: builder.opt(builder.str('entityId')),
    title: builder.opt(builder.str('title')),
    promotionCode: builder.opt(builder.str('promotionCode')),
    promotionName: builder.opt(builder.str('promotionName')),
    storeSpecification: builder.opt(builder.str('storeSpecification')),
    promoWorkflowState: builder.opt(builder.senum('promoWorkflowState', PromotionStateEnum_1.PromotionStateEnum, CodebookLookupSequence_1.CodebookLookupSequence.PromotionWorkflowState)),
    windowWorkflowState: builder.opt(builder.senum('windowWorkflowState', WindowStateEnum_1.WindowStateEnum, CodebookLookupSequence_1.CodebookLookupSequence.WindowWorkflowState)),
    cd: builder.opt(builder.str('cd')),
    cm: builder.opt(builder.str('cm')),
    windowName: builder.opt(builder.str('windowName')),
    windowTypeId: builder.opt(builder.str('windowTypeId')),
    windowTypeName: builder.opt(builder.str('windowTypeName')),
    promoTypeId: builder.opt(builder.str('promoTypeId')),
    promoTypeName: builder.opt(builder.str('promoTypeName')),
    productName: builder.opt(builder.str('productName')),
    startWeekDate: builder.opt(builder.date('startWeekDate', DateParser_1.DateParser.ISO_PATTERN)),
    daysValid: builder.opt(builder.num('daysValid')),
    promoDiscount: builder.opt(builder.bigNum('promoDiscount')),
    workflowNote: builder.opt(builder.str('workflowNote')),
    windowsCount: builder.opt(builder.num('windowsCount')),
    skuCount: builder.opt(builder.num('skuCount')),
    approveButtons: builder.opt(builder.bool('approveButtons')),
    kpiValues: builder.opt(builder.smap(builder.bigNum('kpiValues')))
  };
}();